<label [ngClass]="{ 'm-t-md': toolTip || labelMarginTop, 'form-label': !toolTip }">
  <span
    class="tmo-checkbox"
    [ngClass]="{ disabled: disabled }"
    [class.m-t-sm]="applyCheckboxMargin"
  >
    <input
      #input
      type="checkbox"
      [id]="id"
      [name]="name"
      [checked]="checked"
      [disabled]="disabled"
      [required]="required"
      [tabIndex]="tabindex"
      [attr.aria-label]="ariaLabel"
      [attr.aria-labelledby]="ariaLabelledby"
      [(ngModel)]="value"
      (blur)="onBlur()"
      (click)="onClick($event)"
    />
    <span class="checkbox">
      <i class="fa fa-check"></i>
    </span>
  </span>
  <h6 *ngIf="applyCheckboxMargin" class="title m-l-xl">{{ titleText }}</h6>
  <p
    [class.content]="!teamFollowup && !teamAdjustment"
    [class.n-p]="!teamFollowup && !teamAdjustment"
    [class.small]="teamFollowup || teamAdjustment"
    [class.m-l-xl]="teamFollowup || teamAdjustment"
  >
    <ng-content></ng-content>
  </p>
</label>
